import React, { ReactNode } from 'react';
import { Logo, Avatar, Button, Text } from './ExpertOpinionStyled';
import vshe from './pictures/vshe.png';
import ranhigs from './pictures/ranhigs.png';
import chernobay from './pictures/chernobay.png';
import fedorov from './pictures/fedorov.png';
import appo from './pictures/appo.png';
import zhuravleva from './pictures/zhuravleva.png';
import arhipova from './pictures/arhipova.png';
import saraeva from './pictures/saraeva.png';
import kazanfu from './pictures/kazanfu.png';
import kemerovodo from './pictures/kemerovodo.png';
import tumendo from './pictures/tumendo.png';
import { LogClick } from 'features/shared/ClickStream';

export interface IExpertOpinion {
  title?: string | ReactNode;
  picture?: ReactNode;
  experts?: { fio: string; text?: ReactNode; avatar: ReactNode }[];
  text?: string | ReactNode;
}
const DownloadButton = ({ url, fileName }: { url: string; fileName: string }) => {
  return (
    <LogClick eventType="click_download_pdf" eventInfo={`Скачивание файла ${fileName}`}>
      <Button href={url} download target="_blank">
        Смотреть PDF
      </Button>
    </LogClick>
  );
};
const data: IExpertOpinion[] = [
  {
    title: (
      <>
        Национальный исследовательский университет <br />
        «Высшая школа экономики»
      </>
    ),
    picture: <Logo style={{ backgroundImage: `url(${vshe})` }} />,
    experts: [
      {
        avatar: (
          <>
            <Avatar style={{ backgroundImage: `url(${chernobay})` }} />
            <DownloadButton
              url="https://static.uchi.ru/files/b2g/kabmun_pdf_login/chernobai.pdf"
              fileName="Елена Владимировна Чернобай"
            />
          </>
        ),
        fio: 'ЧЕРНОБАЙ Елена Владимировна',
        text: (
          <>
            Доктор педагогических наук, профессор Российской <br /> академии образования, ведущий эксперт <br />
            Лаборатории проектирования содержания <br />
            образования, профессор Департамента
            <br /> образовательных программ Института образования
            <br /> Национального исследовательского университета
            <br /> «Высшая школа экономики».
          </>
        ),
      },
    ],
  },
  {
    title: 'Сибирский институт управления – филиал РАНХиГС',
    picture: <Logo style={{ backgroundImage: `url(${ranhigs})` }} />,
    experts: [
      {
        avatar: (
          <>
            <Avatar style={{ backgroundImage: `url(${fedorov})` }} />
            <DownloadButton
              url="https://static.uchi.ru/files/b2g/kabmun_pdf_login/fedorov.pdf"
              fileName="Олег Дмитриевич Федоров"
            />
          </>
        ),
        fio: 'ФЁДОРОВ Олег Дмитриевич',
        text: (
          <>
            Кандидат исторических наук, доцент, учитель высшей <br /> категории, лауреат премии Правительства <br />
            Санкт-Петербурга «За гуманизацию школы», лауреат
            <br /> премии Министерства образования и науки РФ,
            <br /> победитель международного конкурса <br />
            «Педагогическое начало», финалист конкурса <br />
            «Лидеры России — 2019», директор сибирского <br />
            филиала РАНХиГС.
          </>
        ),
      },
    ],
  },
  {
    title: 'Санкт-Петербургская академия постдипломного педагогического образования',
    picture: <Logo style={{ backgroundImage: `url(${appo})`, top: -28, position: 'relative' }} />,
    experts: [
      {
        avatar: (
          <>
            <Avatar style={{ backgroundImage: `url(${zhuravleva})` }} />
            <DownloadButton
              url="https://static.uchi.ru/files/b2g/kabmun_pdf_login/zhuravleva.pdf"
              fileName="Ольга Николаевна Журавлёва"
            />
          </>
        ),
        fio: 'ЖУРАВЛЁВА Ольга Николаевна',
        text: (
          <>
            Доктор педагогических наук, профессор, заведующая <br />
            кафедрой социального образования, почётный <br />
            работник общего образования, методист высшей <br />
            категории.
          </>
        ),
      },
    ],
  },
  {
    title: 'Санкт-Петербургская академия постдипломного педагогического образования',
    picture: <Logo style={{ backgroundImage: `url(${appo})`, top: -28, position: 'relative' }} />,
    experts: [
      {
        avatar: <Avatar style={{ backgroundImage: `url(${arhipova})` }} />,
        fio: 'АРХИПОВА Юнонна Ивановна',
        text: (
          <>
            Старший преподаватель кафедры начального
            <br /> образования СПб АППО, победитель конкурса ПНПО
            <br /> РФ «Лучшие учителя», соавтор пособий к УМК «Школа России»
          </>
        ),
      },
      {
        avatar: (
          <>
            <Avatar style={{ backgroundImage: `url(${saraeva})` }} />
            <DownloadButton
              url="https://static.uchi.ru/files/b2g/kabmun_pdf_login/saraeva.pdf"
              fileName="Оксана Анатольевна Сараева, Юнонна Ивановна Архипова"
            />
          </>
        ),
        fio: 'САРАЕВА Оксана Анатольевна',
        text: (
          <>
            Кандидат филологических наук, доцент кафедры
            <br /> начального образования СПб АППО
          </>
        ),
      },
    ],
  },
  {
    title: 'Казанский (Приволжский) федеральный университет',
    picture: <Logo style={{ backgroundImage: `url(${kazanfu})` }} />,
    text: (
      <>
        <Text>
          О положительной динамике воздействия образовательной платформы <br />
          Учи.ру на учебные достижения школьников по результатам исследования
          <br /> среди 655 учащихся 2 и 3 классов школ и гимназий Республики Татарстан.
        </Text>
        <DownloadButton
          url="https://static.uchi.ru/files/b2g/kabmun_pdf_login/expert-conclusion-kazan.pdf"
          fileName="Экспертное заключение Казанского федерального университета"
        />
      </>
    ),
  },
  {
    title: 'Департамент образования и науки Кемеровской области',
    picture: <Logo style={{ backgroundImage: `url(${kemerovodo})` }} />,
    text: (
      <>
        <Text>
          Об эффективности использования интерактивных технологий Учи.ру по <br /> результатам исследования среди 455
          учащихся 2-х классов региона.
        </Text>
        <DownloadButton
          url="https://static.uchi.ru/files/b2g/kabmun_pdf_login/expert-conclusion-kemerovo.pdf"
          fileName="Экспертное заключение Департамента образования и науки Кемеровской области"
        />
      </>
    ),
  },
  {
    title: 'Департамент образования и науки Тюменской области',
    picture: <Logo style={{ backgroundImage: `url(${tumendo})` }} />,
    text: (
      <>
        <Text>
          О соответствии Учи.ру ФГОС НОО и ПООП НОО. По результатам <br />
          исследования среди более 420 учащихся третьих классов платформа
          <br /> Учи.ру рекомендована школам Тюменской области и родителям в качестве
          <br /> дополнительного инструмента в обучении, способствующего повышению <br />
          знаний и компетенций учащихся.
        </Text>
        <DownloadButton
          url="https://static.uchi.ru/files/b2g/kabmun_pdf_login/expert-conclusion-tyumen.pdf"
          fileName="Экспертное заключение Департамента образования и науки Тюменской области"
        />
      </>
    ),
  },
];

export default data;
